import { ADD_CUSTOMER_GROUPS, REFRESH_CUSTOMER_DEVICES } from './constants'

export const AddCustomerGroupList = (customerGroupList) => (dispatch) => {
  dispatch({
    type: ADD_CUSTOMER_GROUPS,
    payload: customerGroupList,
  })
}

export const RefreshCustomerDeviceList = (refresh) => (dispatch) => {
  dispatch({
    type: REFRESH_CUSTOMER_DEVICES,
    payload: refresh,
  })
}
